import { useTranslation } from "react-i18next";
import { Badge } from "@/core/ui";
import type { PuzzleStatus } from "./api";

const TONES: Record<PuzzleStatus, "neutral" | "info" | "warning" | "success" | "danger"> = {
  draft: "neutral",
  submitted: "info",
  in_review: "info",
  approved: "warning",
  scheduled: "warning",
  published: "success",
  archived: "neutral",
};

export function StatusBadge({ status }: { status: PuzzleStatus }) {
  const { t } = useTranslation();
  return <Badge tone={TONES[status] ?? "neutral"}>{t(`backlog.status.${status}`)}</Badge>;
}

/** Human label for a status, usable outside a badge (buttons, sentences). */
export function useStatusLabel(): (status: PuzzleStatus) => string {
  const { t } = useTranslation();
  return (status) => t(`backlog.status.${status}`, { defaultValue: status });
}
